import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"

export default styled(Stack)(({ theme }) => ({
  width: "44px",
  height: "44px",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  cursor: "pointer"
}))
